import { render, staticRenderFns } from "./OrderListTop.vue?vue&type=template&id=d80228dc&scoped=true&"
import script from "./OrderListTop.vue?vue&type=script&lang=js&"
export * from "./OrderListTop.vue?vue&type=script&lang=js&"
import style0 from "./OrderListTop.vue?vue&type=style&index=0&id=d80228dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80228dc",
  null
  
)

export default component.exports